import { AnalyticsDashboard } from './AnalyticsDashboard';
import { BA_COVERAGE } from './ba/baCoverageSpec';
import { BaCoverage } from './ba/BaCoverage';
import type { IAnalyticsBodyProps } from './IAnalyticsBodyProps';

/**
 * Тіло «Аналітики» модуля й подання «Панель» (прототип v4): для модуля «Бізнес-аналіз» — «Покриття аналізом» (isBaDash), для решти —
 * загальна аналітика (isDashboard: показники, розподіли, тренд, терміни).
 */
export function AnalyticsBody({ model }: IAnalyticsBodyProps) {
  return model.module.module.key === BA_COVERAGE.module ? <BaCoverage model={model} /> : <AnalyticsDashboard model={model} />;
}
